// ===================================================
// ФАЙЛ: frontend/src/pages/Error/AccountSuspendedPage.jsx
// ===================================================
import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';
import { SUPPORT_EMAIL } from '../../utils/externalLinks';

const AccountSuspendedPage = () => {
  const { logout } = useAuth();

  return (
    <MonumentErrorLayout
      status="SUSPENDED"
      title="Доступ приостановлен"
      description="Аккаунт на паузе. Напишите в поддержку — разберёмся."
      bgImageName="403"
    >
      <div className="mb-err-page__actions-row">
        <a className="mb-err-page__cta" href={`mailto:${SUPPORT_EMAIL}`}>
          Написать в поддержку
        </a>
        <button type="button" className="mb-err-page__cta mb-err-page__cta--secondary" onClick={logout}>
          Выйти
        </button>
      </div>
    </MonumentErrorLayout>
  );
};

export default AccountSuspendedPage;
